const apiUrl = process.env.VITE_API_URL
const baseDomain = process.env.VITE_BASE_DOMAIN
const devMode = process.env.VITE_ENV_MODE === 'development'
const googleMapsApiKey = process.env.VITE_GOOGLE_MAPS_API_KEY
const firebaseApiKey = process.env.VITE_FIREBASE_API_KEY
const firebaseAuthDomain = process.env.VITE_FIREBASE_AUTH_DOMAIN
const firebaseProjectId = process.env.VITE_FIREBASE_PROJECT_ID
const firebaseStorageBucket = process.env.VITE_FIREBASE_STORAGE_BUCKET
const firebaseMessagingSenderId = process.env.VITE_FIREBASE_MESSAGING_SENDER_ID
const firebaseAppId = process.env.VITE_FIREBASE_APP_ID
const subtraceShareLinkBaseUrl = process.env.VITE_SUBTRACE_SHARE_LINK_BASE_URL

export {
  apiUrl,
  baseDomain,
  devMode,
  googleMapsApiKey,
  firebaseApiKey,
  firebaseAuthDomain,
  firebaseProjectId,
  firebaseStorageBucket,
  firebaseMessagingSenderId,
  firebaseAppId,
  subtraceShareLinkBaseUrl,
}
